import React from 'react'
import { IconTheme } from 'components/patterns/themes/themes'

export const MoneyBag = ({ primaryFill }: IconTheme): JSX.Element => {
	return (
		<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.8583 30.9437C20.2046 32.0441 21.2331 32.8421 22.4483 32.8421L24.1769 32.8281C25.8503 32.8141 27.1999 31.4542 27.1999 29.7808C27.1999 28.098 25.8354 26.7334 24.1526 26.7334H22.7806C21.0978 26.7334 19.7333 25.3689 19.7333 23.6861V23.6833C19.7333 22.0173 21.0707 20.6602 22.7367 20.636L23.5263 20.6248C24.749 20.6248 25.7831 21.433 26.1229 22.5437"
				stroke={primaryFill}
				strokeWidth="1.6"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path d="M23.0001 18.8V20.2" stroke={primaryFill} strokeWidth="1.6" strokeMiterlimit="10" strokeLinecap="round" />
			<path
				d="M23.0001 34.4946V32.908"
				stroke={primaryFill}
				strokeWidth="1.6"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M17.8667 13.2002C17.8667 13.2002 6.30082 21.5059 6.72176 33.0989C6.86736 37.1029 10.1788 40.2669 14.1856 40.2669C19.277 40.2669 26.7222 40.2669 31.8135 40.2669C35.8203 40.2669 39.1318 37.1029 39.2774 33.0989C39.6992 21.5059 28.1334 13.2002 28.1334 13.2002"
				stroke={primaryFill}
				strokeWidth="1.6"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M17.8309 13.0923L16.8826 9.51868C16.5884 8.40999 16.8167 7.20815 17.8364 6.68283C18.8411 6.16523 20.4707 5.65845 23.0001 5.65845C25.5295 5.65845 27.1591 6.16523 28.1638 6.68283C29.1835 7.20815 29.4119 8.40999 29.1177 9.51868L28.1694 13.0923"
				stroke={primaryFill}
				strokeWidth="1.6"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.7089 13.2991C17.7089 13.2991 19.5608 12.4172 23.0002 12.4172C26.4396 12.4172 28.2915 13.2991 28.2915 13.2991"
				stroke={primaryFill}
				strokeWidth="1.6"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
